module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAABKUlEQVQ4T5XUQUoDQRCF4T+CBzAXkehWzEYh25xAJdl4Ag9jEsVtAu5VcONK8A6SC+QAQpAnXUmlrZ7pzGqY6fmmqqu6Omyvc+ADWLtnNbfHwBJYddLqG2ACPAGjPcBT4AX4Bi6EKaJ34CDBj5WgQd303ZswITPgyuXUBubQCri0NPcBQwj4MkxB1YBFSIDHDJwC10HKvbTZtkd/qSkiW5tjJfAZ6ANFKIrMfqKU8wjt3b+ImiLz4AIYupR/gDPgM+rmKE1bp81+BY6yD4ttU8JySBEdtvVhhOWQ9mgA3BaqvDnLORZBVv6oKDspe6wJaqryBjSsBmoFhWkeaWpY1Yp95AoQpTwTpq5WC5xowOVHpGE6elBFGFuaimoO3PmzVjFmBd6nCf3wC5gTWRMzK7IdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/close.png
// module id = ToxP
// module chunks = 9